import { createContext } from 'react';

export const TableRowContext = createContext<{
  isEditing: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
  editedRow: Record<string, any> | null;
  setEditedRow: React.Dispatch<React.SetStateAction<Record<string, any>>>;
}>({
  editedRow: null,
  isEditing: false,
  setIsEditing: () => {
    console.log('Row is not wrapped with TableRowContext');
  },
  setEditedRow: () => {
    console.log('Row is not wrapped with TableRowContext');
  },
});
